import { decodeProfileValues } from '@pkgs/api/utils';

import { useShouldHideUserAccountExclusiveContent } from '@/hooks/useShouldHideUserAccountExclusiveContent';
import { useListing } from '@/hooks/queries/useListing';

import styles from './WavyPattern.module.css';

export const WavyPattern = () => {
  const isUAExclusiveListingAndNotSignedIn = useShouldHideUserAccountExclusiveContent();
  const {
    data: { genericListing },
  } = useListing();

  if (isUAExclusiveListingAndNotSignedIn) {
    return null;
  }

  const profile = decodeProfileValues(genericListing.profile);

  return (
    <div className={styles.container} data-testid="wavy-pattern" data-white-background={Boolean(profile.courtagePassus)}>
      {/* oxlint-disable-next-line @next/next/no-img-element */}
      <img
        src="https://uploadcare.engelvoelkers.com/2ba22428-5bfb-4a50-83ed-081412eed17b/"
        alt="wavy pattern"
        loading="lazy"
        height={250}
      />
    </div>
  );
};
